module.exports = __webpack_public_path__ + "static/media/storePurchase_10_15.fbe375f5.png";